/* src/app/app.component.scss */
:root {
  --risc-base-spacing: 30px;
}
.nav-logout-wrapper {
  padding: var(--vwui-size-spacing-lg) 0;
}
.nav-logout-wrapper vwui-icon {
  display: inline-block;
  vertical-align: top;
  --size: 0.8rem;
  margin: 0.3rem 0 0 0.3rem;
}
.nav-version-wrapper {
  text-align: center;
  border-top: 1px solid var(--nav-header-divider-color);
  line-height: 2rem;
  font-size: 0.7rem;
  font-weight: var(--vwui-font-weight-semibold);
  color: var(--vwui-color-neutral-1);
}
/*# sourceMappingURL=app.component-VTCUTRZ5.css.map */
